import { BundleState, GetBundleQuery } from 'data/__generated__';
import { ColumnsSectionContainer, SectionColumn, SectionContainer } from 'components/DetailsView/Section';
import { StateHistory } from 'components/DetailsView/StateHistory';
import { StatusTag } from 'pages/Bundles/components/StatusTag';
import React from 'react';
import { DetailFormSelect } from 'components/DetailsView/DetailFormSelect';
import { BUNDLE_STATES_LABELS } from 'pages/Bundles/constants/states';

export const StatesSection = ({ bundleDetails }: { bundleDetails: GetBundleQuery['bundle'] }) => {
    const { stateHistory, state } = bundleDetails;
    // const { register } = useFormContext();

    const formattedStateHistory = stateHistory.map((stateRecord) => ({
        ...stateRecord,
        state: <StatusTag state={stateRecord.state} />,
    }));

    const stateOptions = [
        { value: BundleState.Created, label: BUNDLE_STATES_LABELS.Created },
        { value: BundleState.Started, label: BUNDLE_STATES_LABELS.Started },
        { value: BundleState.InProgress, label: BUNDLE_STATES_LABELS.InProgress },
        { value: BundleState.Completed, label: BUNDLE_STATES_LABELS.Completed },
        { value: BundleState.Paused, label: BUNDLE_STATES_LABELS.Paused },
        { value: BundleState.Aborted, label: BUNDLE_STATES_LABELS.Aborted },
        { value: BundleState.Archived, label: BUNDLE_STATES_LABELS.Archived },
    ];

    return (
        <SectionContainer title="Historique des états" isInitiallyOpen>
            <ColumnsSectionContainer numberOfColumns={2}>
                <SectionColumn>
                    <StateHistory label="Historique des états" records={formattedStateHistory} />
                </SectionColumn>
                <SectionColumn>
                    {/* TODO: make this work */}
                    {/* <DetailFormSelect<BundleState>
                        label="Statut"
                        options={stateOptions}
                        placeholder="Modifier la valeur"
                        {...register('state')}
                    /> */}
                    <DetailFormSelect<BundleState>
                        label="Statut"
                        options={stateOptions}
                        defaultValue={state}
                        placeholder="Modifier la valeur"
                        name="state"
                    />
                </SectionColumn>
            </ColumnsSectionContainer>
        </SectionContainer>
    );
};
